module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/map.js
 ** module id = ./node_modules/babel-runtime/core-js/map.js
 ** module chunks = 0
 **/